<div class="ds-grid ds-grid--2">
	<!-- Basic Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Basic Input</h3>
			<p class="ds-example__header-subtitle">Standard text input field</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Full Name'"
				[placeholder]="'Enter your name'"
				[fullWidth]="true"
				(valueChange)="onInputChange('basic', $event)">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ basicValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Input with Icon and Tooltip -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">With Icon & Tooltip</h3>
			<p class="ds-example__header-subtitle">Includes information icon and tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Email Address'"
				[color]="'info'"
				[placeholder]="'email@example.com'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Enter a valid email address'"
				[fullWidth]="true"
				(valueChange)="onInputChange('email', $event)">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ emailValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Password Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Password Input</h3>
			<p class="ds-example__header-subtitle">With visibility toggle</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Password'"
				[type]="'password'"
				[placeholder]="'Enter password'"
				[fullWidth]="true"
				(valueChange)="onInputChange('password', $event)">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ passwordValue ? '••••••••' : 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Number Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Number Input</h3>
			<p class="ds-example__header-subtitle">Numeric value input</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Amount'"
				[type]="'number'"
				[placeholder]="'0.00'"
				[fullWidth]="true"
				(valueChange)="onInputChange('number', $event)">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ numberValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Disabled Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled State</h3>
			<p class="ds-example__header-subtitle">Read only value</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				[label]="'Disabled'"
				[placeholder]="'Cannot edit'"
				[disabled]="true"
				[value]="'Read only value'"
				[fullWidth]="true">
			</eif-custom-input>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ disabledValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Required Input (validation on button) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Required Input</h3>
			<p class="ds-example__header-subtitle">Validation on button click</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#validationInput
				[label]="'Username'"
				[placeholder]="'Enter username'"
				[fullWidth]="true"
				[validationRules]="requiredInputRules"
				(valueChange)="onInputChange('required', $event)"
				(validationChange)="onValidationChange($event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ requiredValue || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
